import MediaSection from 'components/MediaSection/MediaSection';
import { MISSION_STATEMENT_VIDEO_LINK } from 'components/MediaSection/constants';
import ProfileCardSmall from 'components/ProfileCardSmall/ProfileCardSmall';

import JohnP from 'assets/images/leadership_team/jon_purizhansky.png';

const MissionStatement = () => {
  return (
    <MediaSection
      mainText=""
      highlightText="Mission statement"
      videoLink={MISSION_STATEMENT_VIDEO_LINK}
      colorScheme="light"
    >
      <ProfileCardSmall
        imageSrc={JohnP}
        name="Jon Purizhansky"
        title="Founder / CEO"
      />

      <p>
        Joblio’s global network recruits diverse talent to connect employers
        with the workers they need. From general labor to skilled positions, we
        help businesses grow with a deep catalog of qualified individuals who
        are eager to work. And we support businesses in keeping great employees
        through our proprietary support program. Less turnover, increased
        productivity. That’s the Joblio advantage.
      </p>
    </MediaSection>
  );
};

export default MissionStatement;
